import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

// Custom layout
import MainLayout from "../../../../Layouts/Main";

// styles
import "./styles.scss";

// assets
import assets from "../../../../Assets";

//slice
import { fetchIndividualBanner } from "../../../../Redux/Slices/contentManagementSlice";

const ViewBanner = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [bannerData, setBannerData] = useState(null);

    useEffect(() => {
        dispatch(
          fetchIndividualBanner({
            data: {
              id: id
            },
            callBack: fetchBannerCB,
          })
        );
    }, [id]);

    const fetchBannerCB = (data) => {
        console.log(data.result);
        setBannerData(data.result);
    };

    return (
        <MainLayout pageName={"Content Management"}>
            <div className="goBackDiv" onClick={() => navigate(-1)}>
                <img src={assets.Icons.leftArrow} alt="backIcon" />
                <p>Back to Banners List</p>
            </div>
            <div className="banner-profile-details">
                <div className="view-banner-container-header">
                    <h2>View Banners/Promotions Details</h2>
                </div>

                <hr style={{ backgroundColor: "#E6E6E6" }} />

                <div className="banner-details-container">
                    {bannerData ? (
                        <>
                            <div className="banner-details-item">
                                <div className="objKey">Title</div>
                                <div>: {bannerData.banner_title ?? "Not Captured"}</div>
                            </div>
                            <div className="banner-details-item">
                                <div className="objKey">Description</div>
                                <div>: {bannerData.description ?? "Not Captured"}</div>
                            </div>
                            <div className="banner-details-item">
                                <div className="objKey">Start Date</div>
                                <div>: {new Date(bannerData.start_date).toLocaleDateString('en-GB') ?? "Not Captured"}</div>
                            </div>
                            <div className="banner-details-item">
                                <div className="objKey">End Date</div>
                                <div>: {new Date(bannerData.end_date).toLocaleDateString('en-GB') ?? "Not Captured"}</div>
                            </div>
                            <div className="banner-details-item">
                                <div className="objKey">File</div>
                                <div>: {<a href={bannerData.banner_image}>{bannerData.banner_image.split('---').pop()}</a>}</div>
                            </div>
                        </>
                    ) : ""}
                </div>
            </div>
        </MainLayout>
    );
};

export default ViewBanner;
